<template>
  <Stack class="questions-view">
    <Stack gap="2">
      <Title>Questionnaires</Title>
      <p>Display links to the questionnaires.</p>
      <div>
        <Toggle v-model="clientPortalStore.portalRequest.ask_for_questionnaires">
          Ask the client to fill the Questionnaires
        </Toggle>

        <YesNoBadge
          :bool="clientPortalStore.portalRequest.ask_for_questionnaires"
          yes-label="Enabled"
          no-label="Disabled"
        />
      </div>
    </Stack>

    <Stack
      v-if="clientPortalStore.portalRequest.ask_for_questionnaires"
      gap="3"
    >
      <Title size="5">Which questionnaires to display</Title>

      <div
        v-for="q in availableQuestionnaires"
        :key="q.key"
      >
        <Toggle
          :model-value="isEnabled(q.key)"
          @update:model-value="toggle(q.key, $event)"
        >
          {{ q.label }}
        </Toggle>
      </div>
    </Stack>
  </Stack>
</template>

<script setup>
import { Stack, Title, Toggle, YesNoBadge } from '@stakeui';
import { useClientPortalStore } from '@frontend/ui/stores/clientPortalStore';

const clientPortalStore = useClientPortalStore();

defineProps({
  entityExternalId: {
    type: String,
    default: '',
  },
});

const availableQuestionnaires = [
  { key: 'risk', label: 'Risk Questionnaire' },
  { key: 'values', label: 'Behavioral Values Questionnaire' },
  { key: 'picker', label: 'Values Picker' },
];

const isEnabled = key =>
  clientPortalStore.portalRequest.questionnaire_types.includes(key);

const toggle = (key, enabled) => {
  const types = clientPortalStore.portalRequest.questionnaire_types;
  if (enabled) {
    if (!types.includes(key)) types.push(key);
  } else {
    clientPortalStore.portalRequest.questionnaire_types = types.filter(k => k !== key);
  }
};
</script>
